import axios from 'axios'

export default {
  getCostCategoriess ( params, callback ) {
    axios.get('/cost-categories', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getCostCategory ( departmentId, callback, fallback ) {
    axios.get('/cost-categories/' + departmentId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/cost-categories', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( departmentId, data, callback, fallback ) {
    axios.post( '/cost-categories/' + departmentId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( departmentId, callback, fallback ) {
    axios.delete( '/cost-categories/' + departmentId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
}
